import React from 'react';
import { Redirect, Route, Switch, Link, withRouter } from 'react-router-dom';
import { Card, Menu } from 'antd';
import ServicePackagesPage from './ServicePackages';
import UnitConfigPage from './UnitConfig';
import RevenuePage from './Revenue';
import ExpensesPage from './Expenses';
import InstallmentsPage from './Installments';
import ReportingPage from './Reporting';
import SettingsPage from './Settings';
import DashboardPage from './Dashboard';
import CalendarPage from './Calendar';
import { buildMarketplaceOwnerReportingUri } from 'utils/routes';
import { OwnerReportingHostPicker, OwnerReportingHostProvider, useOwnerReportingHost } from '../hooks/useOwnerReportingHost';
import { buildTabHref } from './pageFilters';

const MENU_KEYS = [
  { key: 'dashboard', path: 'dashboard' },
  { key: 'calendar', path: 'calendar' },
  { key: 'service-packages', path: 'service-packages' },
  { key: 'unit-config', path: 'unit-config' },
  { key: 'revenue', path: 'revenue' },
  { key: 'expenses', path: 'expenses' },
  { key: 'installments', path: 'installments' },
  { key: 'reporting', path: 'reporting' },
  { key: 'settings', path: 'settings' },
];

const getSelectedMenuKey = pathname => {
  const path = String(pathname || '');
  const matched = MENU_KEYS.find(item => path.includes(`/owner-reporting/${item.path}`) || path.endsWith(`/${item.path}`));
  return matched ? matched.key : 'dashboard';
};

const OwnerReportingShell = ({ match, location }) => {
  // react-router v4: use match from withRouter (no useRouteMatch)
  const path = (match && match.path) || buildMarketplaceOwnerReportingUri();
  const url = (match && match.url) || buildMarketplaceOwnerReportingUri();
  const { hostId, isAdmin } = useOwnerReportingHost();
  const withHost = to => buildTabHref(to, location && location.search, hostId);
  const selectedKey = getSelectedMenuKey(location && location.pathname);

  return (
    <div>
      <Card bodyStyle={{ padding: 0 }} style={{ marginBottom: 16 }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 16px',
            minHeight: 46,
          }}
        >
          <Menu
            mode="horizontal"
            selectedKeys={[selectedKey]}
            style={{ flex: 1, borderBottom: 'none', lineHeight: '46px' }}
          >
            <Menu.Item key="dashboard">
              <Link to={withHost(`${url}/dashboard`)}>Dashboard</Link>
            </Menu.Item>
            <Menu.Item key="calendar">
              <Link to={withHost(`${url}/calendar`)}>Calendar</Link>
            </Menu.Item>
            <Menu.Item key="service-packages">
              <Link to={withHost(`${url}/service-packages`)}>Service Packages</Link>
            </Menu.Item>
            <Menu.Item key="unit-config">
              <Link to={withHost(`${url}/unit-config`)}>Unit Config</Link>
            </Menu.Item>
            <Menu.Item key="revenue">
              <Link to={withHost(`${url}/revenue`)}>Revenue</Link>
            </Menu.Item>
            <Menu.Item key="expenses">
              <Link to={withHost(`${url}/expenses`)}>Expenses</Link>
            </Menu.Item>
            <Menu.Item key="installments">
              <Link to={withHost(`${url}/installments`)}>Instalments</Link>
            </Menu.Item>
            <Menu.Item key="reporting">
              <Link to={withHost(`${url}/reporting`)}>Manage Reporting</Link>
            </Menu.Item>
            {isAdmin && (
              <Menu.Item key="settings">
                <Link to={withHost(`${url}/settings`)}>Event Actions</Link>
              </Menu.Item>
            )}
          </Menu>
          <div style={{ display: 'flex', alignItems: 'center', marginLeft: 16, flexShrink: 0 }}>
            <OwnerReportingHostPicker />
          </div>
        </div>
      </Card>
      <div style={{ padding: 8 }}>
        <Switch>
          <Route exact path={path} render={() => <Redirect to={withHost(`${path}/dashboard`)} />} />
          <Route path={`${path}/dashboard`} component={DashboardPage} />
          <Route path={`${path}/calendar`} component={CalendarPage} />
          <Route path={`${path}/service-packages`} component={ServicePackagesPage} />
          <Route path={`${path}/unit-config`} component={UnitConfigPage} />
          <Route path={`${path}/revenue`} component={RevenuePage} />
          <Route path={`${path}/expenses`} component={ExpensesPage} />
          <Route path={`${path}/installments`} component={InstallmentsPage} />
          <Route path={`${path}/reporting`} component={ReportingPage} />
          <Route
            path={`${path}/settings`}
            render={() => (isAdmin ? <SettingsPage /> : <Redirect to={withHost(`${path}/dashboard`)} />)}
          />
        </Switch>
      </div>
    </div>
  );
};

const OwnerReportingApp = ({ match, location }) => (
  <OwnerReportingHostProvider>
    <OwnerReportingShell match={match} location={location} />
  </OwnerReportingHostProvider>
);

export default withRouter(OwnerReportingApp);
